import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-push-notification-details',
  templateUrl: './push-notification-details.component.html',
  styleUrls: ['./push-notification-details.component.scss'],
})
export class PushNotificationDetailsComponent implements OnInit {
  @Input() value: any = {};
  notifDetails: any;
  imageBaseUrl = environment.mediaBaseUrl;

  constructor(
    private router: Router,
    private drawerReference: NzDrawerRef,
  ) {}

  ngOnInit(): void {
    this.notifDetails = this.value;
  }

  updateNotification() {
    this.drawerReference.close();
    this.router.navigate([
      '/',
      'main',
      'push-notifications',
      'update',
      this.notifDetails._id,
    ]);
  }
}
